'use client'

import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../utils/cn'

const labelVariants = cva('cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70', {
  variants: {
    variant: {
      default: '',
    },
    line: {
      default: 'leading-5',
    },
    size: {
      small: 'text-[14px]',
      default: 'text-[16px]',
    },
    weight: {
      default: 'font-light', // 300
      medium: 'font-medium', // 500
      // default: 'h-9 px-4 py-2',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
    weight: 'default',
    line: 'default',
  },
})
// const buttonVariants = cva(
//   'inline-flex items-center justify-center whitespace-nowrap rounded-md text-description transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-auto disabled:opacity-50 disabled:cursor-not-allowed',
//   {
//     variants: {
//       variant: {
//         default:
//           // 'bg-primary text-primary-foreground rounded-full border-primary  leading-5	 border hover:bg-buttonDefault-hover transition-all',
//           'bg-primary text-primary-foreground rounded-full border-primary  leading-5	 border  hover:bg-buttonDefault-hover  disabled:hover:bg-primary   disabled:hover:text-primary-foreground  transition-all',
//         destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
//         outline:
//           'rounded-full border-primary  leading-5	 border bg-background shadow-sm hover:bg-primary hover:text-buttonOutline transition-all',
//         secondary: 'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
//         ghost: 'hover:opacity-50 hover:transition-opacity text-primary spacing-0 p-0 text-description',
//         // ghost: 'hover:bg-accent hover:text-accent-foreground text-primary',
//         // ghost: 'hover:bg-accent hover:text-accent-foreground',
//         link: 'text-primary underline-offset-4 hover:underline',
//         // icon: 'rounded-full border-primary border transition-all',
//         icon: 'rounded-full border-primary border hover:bg-primary hover:text-buttonOutline transition-all',
//       },
//       size: {
//         default: 'px-4 py-3',
//         empty: '',
//         // default: 'h-9 px-4 py-2',
//         sm: 'h-8 rounded-md px-3 text-xs',
//         lg: 'h-10 rounded-md px-8',
//         icon: 'p-3',
//         textIcon: 'px-4 py-3',
//       },
//       weight: {
//         default: 'font-light', // 300
//         medium: 'font-medium', // 500
//         // default: 'h-9 px-4 py-2',
//       },
//     },
//     defaultVariants: {
//       variant: 'default',
//       size: 'default',
//       weight: 'default',
//     },
//   },
// )
const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, variant, line, size, weight, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    // className={cn(labelVariants(), className)}
    className={cn(labelVariants({ variant, line, size, weight }), className, '')}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
